module.exports = __webpack_public_path__ + "img/mesacompc.29709439.webp";